export default "__VITE_ASSET__CVsu9XEi__"